module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-04-f328db2c7c4eb012ed7b0fefb4564b31.jpg";